import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonUploadForm } from "../../../Pages/VideoLessons/Ivideolessons";

// 👇 Combine the interfaces to represent a full video upload item
export type IVideoUpload = VideoLessonUploadForm;

export const ListVideoUploadSlice = createSlice({
  name: "ListVideoUploadSlice",
  initialState: {} as IReduxState<IVideoUpload[]>,
  reducers: {
    listVideoUpload: (state) => {
      state.isLoading = true;
    },

    successListVideoUpload: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListVideoUpload: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  listVideoUpload,
  successListVideoUpload,
  failureListVideoUpload,
} = ListVideoUploadSlice.actions;

export default ListVideoUploadSlice.reducer;
